import React, { Component } from "react";
import { Trash2, Edit3 } from "react-feather";
import pin from "views/profile/img/pin.png";
import img1 from "views/profile/img/bookmark/img1.png";
import img2 from "views/profile/img/bookmark/img2.png";
import { GetAllBookMarkAction } from "store/Bookmark";
import { connect } from "react-redux";
import moment from "moment";
class Education extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
    };
  }
  addDefaultSrc(ev) {
    ev.target.src = img1;
  }
  async componentDidMount() {
    try{
    let payload = {
      user_id: this.props.Auth.MGID,
    };
    let response = await this.props.GetAllBookMarks(payload);
    if (response) {
      this.setState({ jobs: response.Data });
    }
  }
  catch(e){
    console.log(e)
  }
  }
  render() {
    return (
      <card className="rounded-12px drop-shadow20 bg-white block lg:p-8 md:p-8 p-5 mt-2  sm-shadow-none">
        <div className="lg:px-12 md:px-12 pb-6">
          <div className="lg:grid md:grid lg:grid-cols-3 md:grid-cols-3 gap-12">
            {/* post graduation */}
            {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
            {this.state.jobs
              ? this.state.jobs.map((job) => (
                  <card className="rounded-sm borderblue-t-5px h-342px drop-shadow20 bg-white block px-6 py-4  lg:mb-0 md:mb-0 mb-6 ">
                    <div className="flex justify-between 	">
                      <p className="text-black font-bold fsize16">
                        {job.f_title || "Phone Banking Officer"}
                      </p>
                      <div className="flex items-center">
                        <Trash2 className="text053C6D w-5 h-5" />
                      </div>
                    </div>
                    <p className="border707070-t opacity-20 my-4 	"></p>
                    <div>
                      <div className="flex justify-between items-center mb-3">
                        <div className="flex items-center">
                          <img src={pin} alt="map" />
                          <p className="text074A7F fsize14 ml-2">
                            {job.Location || "India"}
                          </p>
                        </div>
                        <p className="text-black opacity-50 fsize14">
                          {moment(job.f_createdDate).fromNow()}
                        </p>
                      </div>{" "}
                      <p className="text-black fsize12 line-h20px">
                        {job.f_short_description ||
                          `adipisci velit, sed quia non numquam eius modi tempora
                  incidunt ut labore et dolre…`}
                        <span className="textE77817 font-semibold">
                          Read More
                        </span>
                      </p>
                      <div className="chips flex justify-between py-4">
                        <div className="bgE77820-trans rounded-21px p-10-17px">
                          <p className="fsize10 opacity-100 textF06321 font-semibold">
                            {job.JobType || "FULL TIME"}
                          </p>
                        </div>
                        <div className="bgE77820-trans rounded-21px p-10-17px ">
                          <p className="fsize10 font-semibold opacity-100 textF06321">
                            {job.Experience || "0"} YEARS
                          </p>
                        </div>

                        <div className="bgE77820-trans rounded-21px p-10-17px">
                          <p className="fsize10 font-semibold opacity-100 textF06321">
                            {job.Department || "BANKING"}
                          </p>
                        </div>
                      </div>
                      <div>
                        <img
                          onError={this.addDefaultSrc}
                          src={
                            process.env.REACT_APP_IMAGE_BASE_MG +
                            "/" +
                            job.f_path
                          }
                          className="w-119px h-105px"
                        />
                      </div>
                    </div>
                  </card>
                ))
              : []}
            {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
            {/* <card className="rounded-sm borderblue-t-5px h-342px drop-shadow20 bg-white block px-6 py-4 ">
              <div className="flex justify-between 	">
                <p className="text-black font-bold fsize16">
                  Senior Bank Manager
                </p>
                <div className="flex items-center">
                  <Trash2 className="text053C6D w-5 h-5" />
                </div>
              </div>
              <p className="border707070-t opacity-20 my-4 	"></p>
              <div>
                <div className="flex justify-between items-center mb-3">
                  <div className="flex items-center">
                    <img src={pin} alt="map" />
                    <p className="text074A7F fsize14 ml-2">Mumbai</p>
                  </div>
                  <p className="text-black opacity-50 fsize14">3d ago</p>
                </div>{" "}
                <p className="text-black fsize12 line-h20px">
                  adipisci velit, sed quia non numquam eius modi tempora
                  incidunt ut labore et dolre…{" "}
                  <span className="textE77817 font-semibold">Read More</span>
                </p>
                <div className="chips flex justify-between py-4">
                  <div className="bgE77820-trans rounded-21px p-10-17px">
                    <p className="fsize10 opacity-100 textF06321 font-semibold">
                      FULL TIME
                    </p>
                  </div>
                  <div className="bgE77820-trans rounded-21px p-10-17px ">
                    <p className="fsize10 font-semibold opacity-100 textF06321">
                      2-5 YEARS
                    </p>
                  </div>

                  <div className="bgE77820-trans rounded-21px p-10-17px">
                    <p className="fsize10 font-semibold opacity-100 textF06321">
                      COMMERICAL
                    </p>
                  </div>
                </div>
                <div>
                  <img src={img2} alt="image" className="w-119px h-105px" />
                </div>
              </div>
            </card> */}
          </div>
        </div>
      </card>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    featuredjobs: state.Home.home.FEATUREDJOB,
    Auth: state.Auth.user,
    // mgid :state.Auth.user.MGID,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    GetAllBookMarks: async (payload) =>
      await dispatch(GetAllBookMarkAction(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Education);
